import { Component, OnInit } from '@angular/core';
import { AuthService, FormErrors, ForgotForm } from "../login/auth.service";
import { Router } from '@angular/router';

@Component({
  selector: 'app-forgot',
  templateUrl: './forgot.component.html',
  styleUrls: ['./forgot.component.scss']
})
export class ForgotPage implements OnInit {

  public form: ForgotForm = new ForgotForm
  public errors: FormErrors = new FormErrors
  public result: boolean

  constructor(private authService: AuthService, private router: Router) {
  }

  ngOnInit() {}

  recover() {
    this.authService.recover(this.form).then(res => {
        this.result = true;
        this.errors.list = [];
        // this.router.navigate([this.authService.getAuth().isAdmin() ? 'admin' : 'dashboard']);
      }, err => {
          this.result = false;
          this.errors.list = err.json().errors;
      });
  }

  public authorized() {
    return this.authService.getAuth().isAuthorized();
  }
}



// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/forgot/forgot.component.ts